import { PageError } from '/module/error/page-error';
import { usePermissions } from '/module/permissions';
import type { Route } from '/module/routing/types';

function AccessDenied({ children, route }: { children: React.ReactElement; route: Route }) {
  const permissions = usePermissions();

  // Call custom accessDenied function
  if (route.accessDenied?.(permissions)) {
    throw new PageError('permission', { debug: 'Route access denied, missing permissions!' });
  }

  return children;
}

function Suspended({ children, route }: { children: React.ReactElement; route: Route }) {
  const permissions = usePermissions();

  if (permissions.accountState === 'suspended' && !route.accessAllowedIfAccountSuspended) {
    throw new PageError('suspended', { debug: 'Route access denied, account suspended.' });
  }

  // Keep rendering route
  return children;
}

export function AccessPreflight({
  children,
  route,
}: {
  children: React.ReactElement;
  route: Route;
}): React.ReactElement {
  let wrappedChildren = children;

  if (route.accessDenied) {
    wrappedChildren = <AccessDenied route={route}>{wrappedChildren}</AccessDenied>;
  }

  if (!route.accessAllowedIfAccountSuspended) {
    wrappedChildren = <Suspended route={route}>{wrappedChildren}</Suspended>;
  }

  return wrappedChildren;
}
